<template>
  <div id="app" v-if="routerAlive">
    <router-view />
  </div>
</template>

<script>
import queryString from 'query-string'
import axios from '@/utils/request.js'
import _ from 'lodash'
import { PermissionLevel } from '@/configs/constants'
export default {
  provide () {
    const refresh = this.refresh
    const propertyFn = {
      shared: () => {
        const { query } = queryString.parseUrl(window.location.href)
        return query.share
      },
      templateShared: () => {
        const { query } = queryString.parseUrl(window.location.href)
        return query.templateShare
      }
    }
    return new Proxy(
      {
        refresh,
        shared: '',
        templateShared: ''
      },
      {
        get: function (target, property) {
          const fn = propertyFn[property]
          return fn ? fn(target) : target[property]
        }
      }
    )
  },
  data () {
    return {
      routerAlive: true
    }
  },
  methods: {
    async refresh () {
      this.routerAlive = false
      await this.$nextTick()
      this.routerAlive = true
    }
  },
  created () {
    const { query } = queryString.parseUrl(window.location.href)
    const reload = _.once(() => {
      window.parent && window.parent.postMessage('shared:reload', '*', [])
    })
    // 地图分享时，添加http状态码 420 拦截
    if (query.share) {
      this.$store.commit('SET_PERMISSION_LEVEL', PermissionLevel.ANONYM)
      // 添加响应拦截器
      axios.interceptors.response.use(function (response) {
        // 对响应数据做点什么
        return response
      }, function (error) {
        if (error.response && error.response.status === 420) {
          // 强行刷新页面
          reload()
        }
        // 对响应错误做点什么
        return Promise.reject(error)
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">
#app {
  font-family: Source Han Sans SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $font-colorf;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: $font-colorf;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
